const i18nCfg = {
    v: 1709446629349
}
// 语言包 请求时间戳 
export default i18nCfg;